<script setup>
import ArchivedLeadsList from "../../../components/crm/ArchivedLeadsList.vue";

const breadcrumbs = [
    {url: route('crm.leads'), label: _mft('crm:contacts')},
    {url: '', label: _mft('crm:archive.list.title')},
]

</script>

<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar
                :breadcrumbs="breadcrumbs"
            >
                <div class="flex items-center justify-between space-x-4">
                    <h1>{{ _mft('crm:archive.list.title') }}</h1>
                    <a
                        :href="route('crm.leads')"
                        class="mf-link-immune"
                    >
                        <button-base style-type="secondary">
                            {{ _mft('crm:archive.list.back') }}
                        </button-base>
                    </a>
                </div>
            </frosted-bar>
        </div>
        <archived-leads-list />
    </div>
</template>

<style>

</style>
